module.exports = __webpack_public_path__ + "img/section1Model.6662c8d7.png";